<template>
  <HeaderApps />

  <div class="row">
    <aside>
      <slot name="sidemenu" />
    </aside>

    <main>
      <slot name="pagecontent" />
    </main>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

import HeaderApps from '../header/apps'

export default defineComponent({
  name: 'GridDash',

  components: {
    HeaderApps
  }
})
</script>
